var FadeAnime = (function () {
    function FadeAnime() {
        this.triggerElements = document.querySelectorAll('.fadeUpTrigger');
        this.scroll = window.scrollY;
        this.windowHeight = window.innerHeight;
    }
    FadeAnime.prototype.anime = function () {
        var _this = this;
        this.triggerElements.forEach(function (element) {
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            var elemPos = element.getBoundingClientRect().top + scrollTop + 200;
            if (_this.scroll >= elemPos - _this.windowHeight) {
                element.classList.add('fadeUp');
            }
            else {
            }
        });
    };
    FadeAnime.prototype.execute = function () {
        var _this = this;
        window.addEventListener('scroll', function () {
            _this.scroll = window.scrollY;
            _this.anime();
        });
        window.addEventListener('load', function () {
            _this.anime();
        });
    };
    return FadeAnime;
}());
export default FadeAnime;
